/**
 * Created by andrey on 11.08.2025
 */

cc.ActionInterval = function (duration) {
    this._elapsed = 0;
    this._firstTick = false;
    this._easeList = undefined;

    cc.FiniteTimeAction.prototype.constructor.call(this);

    if (duration !== undefined) {
        this.initWithDuration(duration);
    }
};

cc.ActionInterval.prototype = Object.assign(Object.create(cc.FiniteTimeAction.prototype), {
    constructor: cc.ActionInterval,

    getElapsed: function () {
        return this._elapsed;
    },

    initWithDuration: function (d) {
        this._duration = (d === 0) ? cc.FLT_EPSILON : d;
        // prevent division by 0
        // This comparison could be in step:, but it might decrease the performance
        // by 3% in heavy based action games.
        this._elapsed = 0;
        this._firstTick = true;
        return true;
    },

    isDone: function () {
        return (this._elapsed >= this._duration);
    },

    easing: function (...args) {
        this._easeList = [...args];
        return this;
    },

    _computeEaseTime: function (dt) {
        const locList = this._easeList;
        if ((!locList) || (locList.length === 0)) {
            return dt;
        }
        for (let i = 0, n = locList.length; i < n; i++) {
            dt = locList[i](dt);
        }
        return dt;
    },

    step: function (dt) {
        if (this._firstTick) {
            this._firstTick = false;
            this._elapsed = 0;
        } else {
            this._elapsed += dt;
        }

        let t = this._elapsed / (this._duration > cc.FLT_EPSILON ? this._duration : cc.FLT_EPSILON);
        t = (t < 1 ? t : 1);
        this.update(t > 0 ? t : 0);
    },

    startWithTarget: function (target) {
        cc.Action.prototype.startWithTarget.call(this, target);
        this._elapsed = 0;
        this._firstTick = true;
    },

    _autoFinalize: function () {
        if (this.target && !this.isDone()) {
            this.update(1);
        }
        this._elapsed = this._duration;
    }
});

cc.actionInterval = (duration) => new cc.ActionInterval(duration);
